// // create language
// export const CREATE_LANGUAGE = "CREATE_LANGUAGE";

// // get language list
// export const GET_LANGUAGE = "GET_LANGUAGE";

// // handle open close dialog
// export const OPEN_LANGUAGE_DIALOG = "OPEN_LANGUAGE_DIALOG";
// export const CLOSE_LANGUAGE_DIALOG = "CLOSE_LANGUAGE_DIALOG";

// // handle edit language request
// export const EDIT_LANGUAGE = "EDIT_LANGUAGE";

// // delete language (अगर ज़रूरत हो तो)
// export const DELETE_LANGUAGE = "DELETE_LANGUAGE";
// create language
export const CREATE_LANGUAGE = "CREATE_LANGUAGE";

// get language
export const GET_LANGUAGE = "GET_LANGUAGE";

// open/close dialog
export const OPEN_LANGUAGE_DIALOG = "OPEN_LANGUAGE_DIALOG";
export const CLOSE_LANGUAGE_DIALOG = "CLOSE_LANGUAGE_DIALOG";

// edit language
export const EDIT_LANGUAGE = "EDIT_LANGUAGE";

// delete language
export const DELETE_LANGUAGE = "DELETE_LANGUAGE";

// update language (अगर coin/type जैसी update करनी है)
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
